import React from 'react';
import { IconButton } from 'components/buttons/IconButton';
import { AddPhraseColumn } from '../columns';
import './AddPhrase.less';

interface IAddPhraseCellProps extends Omit<React.HTMLProps<HTMLTableHeaderCellElement>, 'onClick'> {
  onAdd: () => void;
}

/**
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function AddPhrase({ className, onAdd, ...otherProps }: IAddPhraseCellProps) {
  return (
    <AddPhraseColumn className={className} {...otherProps} isHeader>
      <IconButton
        aria-label="Add Column"
        title="Add Column"
        className="tt-cell full-size tt-table__add-phrase-btn"
        iconClassName="tt-table__add-phrase-icon"
        onClick={onAdd}
      />
    </AddPhraseColumn>
  );
}
